import { useState } from "react";
import FormBody from './FormBody';
import { Post } from "../../../../utils/request";
import { useDispatch} from "react-redux";
import { Show } from "../../../../actions/SnackbarActions";
import SweetAlert from "react-bootstrap-sweetalert";

const FirstContent = () => {
  const [popup, SetPopup] = useState(false);
  const [popupMessage, SetPopupMessage] = useState("");

  const [loading, SetLoading] = useState(false);

  const dispatch = useDispatch();

  const Submit = async (data) => {
    if(!data?.description){
      SetPopup(true);
      SetPopupMessage("Insira um conteúdo");
      return;
    }
    let form = new FormData();
    form.append("title", data?.title);
    form.append("description", data.description);
    form.append("type", data.type);
    form.append("sub", data?.sub);
    SetLoading(true);
    let response = await Post("site-rt/description/update", form);
    SetLoading(false);
    dispatch(Show({
      show: true,
      message: response?.message,
      severity: response?.severity,
      buttonActionText: "Ver"
    }));

  }
  return (
    <div className="card">
      <SweetAlert 
        warning
        show={popup}
        title="Atenção!"
        confirmBtnText="Ok"
        onConfirm={()=> SetPopup(false)}
      >
        {popupMessage}
      </SweetAlert>
      <div className="card-body">
        <h2 className="title"> 
          Editar primeiro conteúdo do site RT
        </h2>
        <p>Aqui é editado o primeiro conteúdo da página RT</p>
        <br/>
        <FormBody
          OnConfirm={data => Submit(data)}
          loading={loading}
          
        />
      </div>
    </div>
  )
}
export default FirstContent